import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LoginForm from '../../components/auth/LoginForm';

const LoginPage: React.FC = () => {
  const location = useLocation();
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  useEffect(() => {
    // Check if we have a success message from navigation state
    if (location.state && (location.state as any).message) {
      setSuccessMessage((location.state as any).message);
      // Clear the message after 5 seconds
      const timer = setTimeout(() => {
        setSuccessMessage(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [location]);

  return (
    <>
      <h2 className="auth-form__title" style={{ textAlign: 'center' }}>Sign In to Your Account</h2>
      <p className="auth-form__subtitle" style={{ textAlign: 'center', marginBottom: '2rem' }}>Welcome back! Please enter your credentials to access your account.</p>
      
      {successMessage && (
        <div className="auth-form__success-message" style={{
          backgroundColor: '#d1fae5',
          color: '#065f46',
          padding: '12px 16px',
          borderRadius: '8px',
          marginBottom: '16px',
          border: '1px solid #10b981',
          fontSize: '14px'
        }}>
          {successMessage}
        </div>
      )}
      
      <LoginForm />
    </>
  );
};

export default LoginPage;